
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const PlannerDetailPage = lazy(() => import('../pages/planner-detail/page'));
const BoardsPage = lazy(() => import('../pages/boards/page'));
const BoardDetailPage = lazy(() => import('../pages/board-detail/page'));
const FestivalDetailPage = lazy(() => import('../pages/festival-detail/page'));
const PerformanceDetailPage = lazy(() => import('../pages/performance-detail/page'));
const RegionDetailPage = lazy(() => import('../pages/region-detail/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ScamCheckPage = lazy(() => import('../pages/scam-check/page'));
const ScamCheckResultPage = lazy(() => import('../pages/scam-check-result/page'));
const ReportWritePage = lazy(() => import('../pages/report-write/page'));
const TipWritePage = lazy(() => import('../pages/tip-write/page'));
const ReportDetailPage = lazy(() => import('../pages/report-detail/page'));
const TipDetailPage = lazy(() => import('../pages/tip-detail/page'));
const ExplorePage = lazy(() => import('../pages/explore/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'planner/:id', element: <PlannerDetailPage /> },
      { path: 'boards', element: <BoardsPage /> },
      { path: 'boards/:id', element: <BoardDetailPage /> },
      { path: 'festival/:contentId', element: <FestivalDetailPage /> },
      { path: 'performance/:mt20id', element: <PerformanceDetailPage /> },
      { path: 'region/:areaCode', element: <RegionDetailPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'scam-check', element: <ScamCheckPage /> },
      { path: 'scam-check/result', element: <ScamCheckResultPage /> },
      { path: 'report/write', element: <ReportWritePage /> },
      { path: 'tip/write', element: <TipWritePage /> },
      { path: 'report/:id', element: <ReportDetailPage /> },
      { path: 'tip/:id', element: <TipDetailPage /> },
      { path: 'explore', element: <ExplorePage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
